import { render, staticRenderFns } from "./SDOrderForm.vue?vue&type=template&id=4d89be68&scoped=true&"
import script from "./SDOrderForm.vue?vue&type=script&lang=js&"
export * from "./SDOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./SDOrderForm.vue?vue&type=style&index=0&id=4d89be68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d89be68",
  null
  
)

export default component.exports